var dom = require('./dom.html');

import './countdown';

class CountdownBuilder {
  constructor(target, startsAt) {
    this.target = target;
    this.seconds = startsAt  - (Date.now() / 1000);
  }

  setup() {
    this.target.html( $( dom ) );
  }

  start(duration) {
    if (this.seconds < 0) {
      this.updateDisplay(0, 0, 0, 0);
    } else {
      this.computeCountdown();

      setInterval( () => {
        this.computeCountdown();
      }, 1000);
    }
  }

  pad(n) {
    return (n < 10 ? "0" + n : n);
  }

  updateDisplay(days, hours, minutes, seconds) {
    this.target.find("#days").html(this.pad(days));
    this.target.find("#hours").html(this.pad(hours));
    this.target.find("#minutes").html(this.pad(minutes));
    this.target.find("#seconds").html(this.pad(seconds));
  }

  computeCountdown() {
    var days        = Math.floor(this.seconds/24/60/60);
    var hoursLeft   = Math.floor((this.seconds) - (days*86400));
    var hours       = Math.floor(hoursLeft/3600);
    var minutesLeft = Math.floor((hoursLeft) - (hours*3600));
    var minutes     = Math.floor(minutesLeft/60);
    var remainingSeconds = Math.round(this.seconds % 60) ;

    this.updateDisplay(days, hours, minutes, remainingSeconds);

    if (this.seconds > 0) {
      this.seconds--;
    }
  }
}

var buildCountdown = function (startsAt) {

  if (_.isNil(startsAt))
  {
    startsAt = $(this).data('countdown-starts-at');
  }

  var builder = new CountdownBuilder($(this), startsAt);
  builder.setup();
  builder.start();

  return builder;
};

export default buildCountdown;
